import AccountHolderView from "../account-holder-view";

function AccountHolderActiveView() {
  return (
    <AccountHolderView isActivePrograms />
  )
}
export default AccountHolderActiveView;